module.exports = "<div class=\"tooltip-general tooltip-{{status}}\" [attr.data-content]=\"text\">\n    <i class=\"{{ setCorrectIcon() }} cross-tooltip\"></i>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/tooltips/icon-tooltip/icon-tooltip.component.html
// module id = ./shared/components/common/tooltips/icon-tooltip/icon-tooltip.component.html
// module chunks = 0